<template>
		<main id="form">
			<form autocomplete="off" v-on:submit.self.stop.prevent="validateForm()">
				<h2>{{this.properties && getLabel(this.properties.title)}}</h2>
				<ul v-if="properties.fields">
					<li>
						<pools_radio_input v-on:validateField="validateExtraInput" v-bind:params="getParams('assessment')" v-bind:oldValue="oldValue['assessment']" v-bind:lang="lang"></pools_radio_input>
					</li>
					<!-- <li v-if="this.display.assessment == '0'">
						<pools_checkbox_input v-on:validateField="validateField" v-bind:params="getParams('feeling')" v-bind:oldValue="oldValue['feeling']" v-bind:lang="lang"></pools_checkbox_input>
					</li> -->
					<li>
						<text_input v-on:validateField="validateField" v-bind:params="getParams('name')" v-bind:oldValue="oldValue['name']" v-bind:lang="lang"></text_input>
					</li>
					<!-- <li> -->
						<!-- <text_input v-on:validateField="validateField" v-bind:params="getParams('comments')" v-bind:oldValue="oldValue['comments']" v-bind:lang="lang"></text_input> -->
					<!-- </li> -->
					<li>
						<textarea_input v-on:validateField="validateField" v-bind:params="getParams('comments')" v-bind:oldValue="oldValue['comments']" v-bind:lang="lang"></textarea_input>

					</li>
				</ul>

				<button v-bind:class="isActive ? 'selected' : ''" type="submit">{{getLabel(fields.next)}}</button>
			</form>
		</main>
	</template>

	<script>
	//Input components
	import text_input from '@/components/candidate_forms/text_input.vue';
	import textarea_input from '@/components/candidate_forms/textarea_input.vue';
	import radio_input from '@/components/candidate_forms/radio_input.vue';
	import pools_radio_input from '@/components/candidate_forms/pools_radio_input.vue';
	import pools_checkbox_input from '@/components/candidate_forms/pools_checkbox_input.vue';
	import number_input from '@/components/candidate_forms/number_input.vue';
	import month_input from '@/components/candidate_forms/month_input.vue';
	import lib from '@/libs/main.js';
	import componentTools from '@/libs/componentTools.js';

	function checkForm(scope){
		return ['assessment','name', 'comments'].every(e => scope.answer[e]);
	}

	export default {
		name: 'ratingEyTpl',
		data() {
			return {
				answer : {},
				oldValue : {},
				display : {
					assessment : '',
					name : false,
					comments : false,
				},
				isActive : false,
				fields : {
					next : {
						fr : 'Valider',
						en : 'Next'
					}
				},
			}
		},
		props : ['currentSession', 'properties', 'lang', 'templateIndex'],
		components : {
			text_input, radio_input, pools_radio_input, number_input, pools_checkbox_input, month_input, textarea_input
		},
		methods : {
			validateForm : function() {
				if(!checkForm(this)) return;
				let out = {};
				this.properties.fields.forEach( field => {
					if(this.answer[field.params.name]) out[field.params.name] = this.answer[field.params.name];
				});
				if(out.name && out.name.length) {
					const toSave = out.name
					if(toSave.length){
						try{
							localStorage.setItem(this.$options.name + '_' + this.templateIndex, JSON.stringify({name : toSave}));
						}catch(e){console.log(e);}
					}
				}
				this.$emit('validateStep', this.$options.name, out);
			},
			validateField : function(name, value) {
				this.answer[name] = value;
				this.display[name] = value;
				this.isActive = checkForm(this);
			},
			validateExtraInput : function(name, value) {
				const params = this.getParams(name);
				const answer = params && params.options && params.options.find(e => e.value == value);
				if(typeof this.display[name] != "undefined") this.display[name] = value;
				this.answer[name] = value;
				this.isActive = checkForm(this);
			},
			getParams : function(name){
				return this.properties.fields.find(x => x.params && x.params.name == name).params;
			},
			getLabel : componentTools.getLabel,
		},
		watch : {
			currentSession : {
				handler : function(val){
					let candidateTplRes = val.stepsResults && val.stepsResults[this.$options.name + '_' + this.templateIndex];
					if(!candidateTplRes){
						Object.keys(this.answer).forEach(k => this.$set(this.oldValue, k, null)); //cf vue reactivity for binded object properties
						this.answer = {};
					}
				},
				deep : true,
			},
		},
		created : function(){
			componentTools.created.call(this);
			const oldRes = this.currentSession.stepsResults[this.$options.name + '_' + this.templateIndex];
			const tplName = this.$options.name + '_' + this.templateIndex;
			let last_entries = localStorage.getItem(tplName);
			try{last_entries = JSON.parse(last_entries);}catch(e){console.log(e); last_entries = {}}
			if(oldRes) this.oldValue = oldRes;
			else if(!oldRes && last_entries) this.oldValue = last_entries;
		},
		mounted : componentTools.mounted
	};
	</script>

	<style lang="less">
	@import '../../assets/less/conf.import.less';
	#form ul{
		li{
			position: relative;
			margin-top: 3%;
			margin-bottom: 3%;
			label{
				position: absolute;
				left: 0;
				margin-top: 2%;
				max-width: 40%;
				text-align: left;
			}
			input{
				&[type="date"]{
					width: 40%;
					margin-left: 60%;
				}
				&[type="checkbox"], &[type="radio"]{
					display: inline-block;
				}
				&[type="text"]{
					width: 50%;
					margin-left: 50%;
				}
				&[type="email"]{
					width: 50%;
					margin-left: 50%;
				}
				&[type="number"]{
					width: 50%;
					margin-left: 50%;
				}
				&[type="tel"]{
					width: 50%;
					margin-left: 50%;
				}
				&[type="month"]{
					width: 35%;
					margin-left: 65%;
				}
			}
			textarea{
				overflow: hidden;
				resize: none;
				width: 100%;
				height: 8vh;
				min-height: 80px;
				font-size: 14px;
				padding: 1%;
				border-radius: 5px;
			}
		}
	}
	</style>



// WEBPACK FOOTER //
// src/components/ey/ratingEy.vue